// @flow

import { FETCH_SETTINGS_SUCCESS } from 'actions/appActions';
import { FETCH_PAGE_LIST_SUCCESS } from 'actions/pageActions';

import type { ActionType } from 'types/Actions';
import type { HomeCardType, ListHomeCardType } from 'types/Settings';
import type { CardType } from 'types/PageList';

export type State = {
  liste_cards_home: Array<ListHomeCardType>,
  liste_cards: Array<CardType>,
  gerer_club: HomeCardType,
  bulletin_officiel: HomeCardType,
  titre_liste_cards: string,
  titre_liste_blocs_un: string,
};

const initialState: State = {
  liste_cards_home: [],
  liste_cards: [],
  gerer_club: {
    object_id: 0,
    type_name: '',
    object_slug: '',
    parent_slugs: {},
    title: '',
    description: '',
    featured_image: {},
    texte_cta: ''
  },
  bulletin_officiel: {
    object_id: 0,
    type_name: '',
    object_slug: '',
    parent_slugs: {},
    title: '',
    description: '',
    featured_image: {},
    texte_cta: ''
  },
  titre_liste_cards: '',
  titre_liste_blocs_un: '',
};

export default function(state: State = initialState, action: ActionType): State {
  switch (action.type) {
    case FETCH_SETTINGS_SUCCESS:
      return {
        ...state,
        liste_cards_home: action.payload.settings.liste_cards,
        gerer_club: action.payload.settings.gerer_club,
        bulletin_officiel: action.payload.settings.bulletin_officiel,
        titre_liste_cards: action.payload.settings.titre_liste_cards,
        titre_liste_blocs_un: action.payload.settings.titre_liste_blocs_un,
      };
    case FETCH_PAGE_LIST_SUCCESS:
      return {
        ...state,
        liste_cards: action.payload.pageList.liste_enfants,
      };
    default:
      return state;
  }
}
